// initial state
// shape: [{ id, quantity }]
const state = {
  userOptions: [],
}

// getters
const getters = {
  // demoTable: state => state.table
}

// actions
const actions = {
  getTekeTagTable ({commit, state}, params) {
    let promised = request.alert('getTekeTagTable', params)
    return promised
  },
  createTekeTag ({commit, state}, params) {
    let promised = request.alert('createTekeTag', params)
    return promised
  },
  editTekeTag ({commit, state}, params) {
    let promised = request.alert('editTekeTag', params)
    return promised
  },
  deleteTekeTag ({commit, state}, id) {
    let promised = request.alert('deleteTekeTag', id)
    return promised
  },
  getTekeInfiniteTagTable ({commit, state}, params) {
    let promised = request.alert('getTekeInfiniteTagTable', params)
    return promised
  },

  createTekeInfiniteTag ({commit, state}, params) {
    let promised = request.alert('createTekeInfiniteTag', params)
    return promised
  },
  editTekeInfiniteTag ({commit, state}, params) {
    let promised = request.alert('editTekeInfiniteTag', params)
    return promised
  },
  getTekeTag ({commit, state}, id) {
    let promised = request.alert('getTekeTag', id)
    return promised
  },
  batchAddTeke ({commit, state}, id) {
    let promised = request.alert('batchAddTeke', id)
    return promised
  },
  batchDeleteTeke ({commit, state}, id) {
    let promised = request.alert('batchDeleteTeke', id)
    return promised
  },
  getTekeInfiniteTagUpload ({commit, state}, params) {
    let promised = request.alert('getTekeInfiniteTagUpload', params)
    return promised
  },
  downTekeSourceFile ({commit, state}, id) {
    let promised = request.alert('downTekeSourceFile', id)
    return promised
  },
  downTekeErrorFile ({commit, state}, id) {
    let promised = request.alert('downTekeErrorFile', id)
    return promised
  },
  batchUploadTekeTagEdit ({commit, state}, params) {
    let promised = request.alert('batchUploadTekeTagEdit', params)
    return promised
  },
  batchUploadTekeTagLib ({commit, state}, params) {
    let promised = request.alert('batchUploadTekeTagLib', params)
    return promised
  },
  downloadAllTagFile ({commit, state}, params) {
    let promised = request.alert('downloadAllTagFile', params)
    return promised
  },
  getBatchjobOnGoingNumber ({commit, state}, params) {
    let promised = request.alert('getBatchjobOnGoingNumber', params)
    return promised
  },
}

// mutations
const mutations = {}

export const tekeTag = {
  state,
  getters,
  actions,
  mutations,
}



// WEBPACK FOOTER //
// ./src/views/teke-tag/tekeTag.store.js